<template>
  <div class="bbe-access">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun" />
    </transition>
    <div class="bbe-access-search">
      <i class="email-icon-search bbe-access-search__icon"/>
      <input class="bbe-input bbe-access-search__input"
               type="text"
               @input="searchUser"
               placeholder="Search">
    </div>
    <VuePerfectScrollbar ref="scroll" class="bbe-access-body" :settings="{minScrollbarLength: 25}">
      <div class="bbe-access-body-item"
           v-for="(user, index) in currentList"
           :key="user.id"
           @click="setValueCheckbox(user)">
        <div class="bbe-access-body-item-user">
          <div class="bbe-access-body-item-user-image">
            <img class="bbe-access-body-item-user-image__avatar"
                 :src="user.image? user.image.path : defaultAvatar" alt="">
          </div>
         <div class="bbe-access-body-item-user-description">
           <p class="bbe-access-body-item-user-description__name">{{user.username}}</p>
           <p class="bbe-access-body-item-user-description__email">{{user.email}}</p>
         </div>
        </div>
        <checkbox :name="user"
                  @checkboxChange="checkedRole"
                  :value="getValueCheckbox(user)"/>
        <div class="bbe-access-body-observe" v-if="(currentList.length - index) === 15"
             v-observe-visibility="handleScrollToBottom"></div>
      </div>
      <transition name="fade" appear>
      <div class="bbe-access-body-item bbe-access-body-item_loader" v-if="loaderRunNextPage" >
          <loader-fly :block-mode="true" />
      </div>
      </transition>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Checkbox from '@/components/Main/FormsElements/checkbox'
import UsersApi from '@/api/Users/api'
import defaultAvatar from '@/assets/images/user.png'
import {debounce} from 'lodash'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'

export default {
  name: 'ConfigureAccess',
  props: ['template'],
  components: {
    Checkbox,
    VuePerfectScrollbar,
    LoaderFly
  },
  data () {
    return {
      searchList: [],
      checkedUser: this.template.allowedUsers || [],
      defaultAvatar: defaultAvatar,
      searchValue: '',
      limit: 100,
      loaderRun: false,
      loaderRunNextPage: false,
      totalPages: 0,
      currentPage: 1
    }
  },
  computed: {
    userListMail: {
      get () {
        return this.$store.getters.userListMail
      },
      set (data) {
        this.$store.dispatch('setUserListMail', data)
      }
    },
    setDebounceSearch () {
      return debounce(this.getUserList, 500)
    },
    currentList: {
      get () {
        return this.searchValue ? this.searchList : this.userListMail
      },
      set (data) {
        this.searchValue ? this.searchList = data : this.userListMail = data
      }
    }
  },
  methods: {
    getValueCheckbox (user) {
      return this.checkedUser.includes(user.id)
    },
    checkedRole (data, user) {
      this.setValueCheckbox(user, data)
    },
    setValueCheckbox (user, data) {
      const isUSerChecked = this.checkedUser.includes(user.id)
      if (isUSerChecked) {
        this.checkedUser = this.checkedUser.filter(el => el !== user.id)
      } else {
        this.checkedUser.push(user.id)
      }
      this.$emit('changeValue', this.checkedUser)
    },
    getUserList () {
      this.currentPage === 1 ? this.loaderRun = true : this.loaderRunNextPage = true
      const search = this.searchValue
      const page = this.currentPage
      const limit = this.limit
      this.scrollTop()
      UsersApi.getUsersList({limit, search, page})
        .then(resp => {
          if (this.currentPage === 1) {
            this.currentList = resp.data.users
          } else {
            this.currentList.push(...resp.data.users)
          }
          this.totalPages = resp.data.totalPages
          this.loaderRun = false
          this.loaderRunNextPage = false
        })
        .catch(err => {
          console.error(err)
          this.loaderRun = false
        })
    },
    searchUser (e) {
      this.searchValue = e.target.value
    },
    handleScrollToBottom (isVisible) {
      if (!isVisible) return
      if (this.totalPages > this.currentPage) {
        this.currentPage++
        this.getUserList()
      }
    },
    scrollTop () {
      if (this.$refs.scroll) {
        this.$refs.scroll.$el.scrollTop = 0
        this.$refs.scroll.$el.scrollLeft = 0
      }
    }
  },
  watch: {
    searchValue (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDebounceSearch()
        this.currentPage = 1
      }
    },
    currentPage (newVal) {
      if (newVal === 1) {
        this.scrollTop()
      }
    }
  },
  beforeMount () {
    this.getUserList()
    if (!this.template) return
    const access = this.template.roles || []
    this.checkedRoles = [...access]
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbe-access {
    @include global-font;
    display: flex;
    flex-direction: column;

    &-search {
      margin: 18px auto 0;
      display: flex;
      align-items: center;
      width: 440px;
      height: 35px;
      border: 1px solid $color-silver-deep;
      border-radius: 6px;

      &__icon {
        color: $color-silver-deep;
        font-size: 14px;
        margin: 10px 12px;
      }

      &__input {
        background: transparent;
      }
    }
    &-body {
      margin: 20px 0 0;
      max-height: 232px;
      padding-bottom: 25px;
      overflow: hidden;

      &-item {
        position: relative;
        padding: 0 20px;
        height: 44px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        transition: .2s;

        &_loader {
          margin-top: 25px;
        }

        &:hover {
          &:after {
            content: none;
          }
          background-color: $color-wild-sand;
        }

        &-user {
          display: flex;

          &-image {

            &__avatar {
              width: 36px;
              height: 36px;
              border-radius: 50%;
              margin-right: 12px;
            }
          }

          &-description {
            display: flex;
            justify-content: center;
            flex-direction: column;

            &__name {
              font-size: 12px;
              line-height: 120.34%;
              color: $color-black;
              text-transform: capitalize;
            }

            &__email {
              font-size: 11px;
              line-height: 120.34%;
              color: $color-silver-chalice;
            }
          }
        }
      }

      &-observe {
        position: absolute;
        pointer-events: none;
      }
    }
  }

</style>
<style lang="scss">
@import "../../../sass/variables";

.bbe-access-body {
  .ps__rail-y.ps--clicking .ps__thumb-y, .ps__rail-y:focus > .ps__thumb-y,
  .ps__rail-y:hover > .ps__thumb-y,
  .ps .ps__thumb-y {
    width: 6px;
    background-color: $color-accent;
    z-index: 3;
  }
  .ps__rail-x, .ps__rail-y {
    z-index: 3;
    width: 6px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Templates/TemplatesSidebar/ConfigureAccess.vue